import { render, staticRenderFns } from "./ChooseRecord.vue?vue&type=template&id=054fdfac&"
import script from "./ChooseRecord.vue?vue&type=script&lang=js&"
export * from "./ChooseRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports